<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <Header />
    <div class="bodyCenter">
      <div class="modalStyle">
        <div class="titulos">
          <div class="seccionTitle">
            <b-icon class="iconuser mLeft" icon=" geo-alt"></b-icon>
            <div class="headerTxt mLeft">Colonias / C.P.</div>
          </div>
          <div class="alignIcon bold">COL_01</div>
        </div>

        <div class="noAlTope">
          <b-tabs content-class="mt-3">
            <b-tab title="ALTA DE CODIGO POSTAL" active>
              <br />
              <div v-if="$localStorageService.can('COL_01_alta_cp')">
                <AltaCp />
              </div>
            </b-tab>
            <b-tab title="CODIGOS POSTALES">
              <div v-if="$localStorageService.can('COL_01_consul_cp')">
              <BuscarCp />
              </div>
            </b-tab>
          </b-tabs>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
//components
import Header from "../components/Header.vue";
import AltaCp from "../components/codigoPostal/AltaCp.vue";
import BuscarCp from "../components/codigoPostal/BuscarCp.vue";
export default {
  name: "ColoniaCp",
  components: {
    Header,
    AltaCp,
    BuscarCp,
  },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
  }),
  created() {
    this.debug = this.$localStorageService.getDebug();
  }
};
</script>
